<template>
  <v-layout row wrap fill-height>
    <v-toolbar app dense color="primary">
      <v-toolbar-title style="color:black;" @click="goToHome">SuburbanServ - Supervisor</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="logout">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content style="height: calc(100% - 56px); overflow: auto;">
      <router-view></router-view>
    </v-content>

    <v-bottom-nav :active.sync="activeBtn" :value="true" color="primary" fixed>
      <v-btn flat color="white" value="Customers" @click="$router.push('/Supervisor/Customers')">
        <span>Inspections</span>
        <v-icon>mdi-account-group</v-icon>
      </v-btn>

      <v-divider vertical></v-divider>

      <v-btn flat color="white" value="AllocateInspection" @click="$router.push('/Supervisor/AllocateInspection')">
        <span>Allocate Inspection</span>
        <v-icon>mdi-eye-plus</v-icon>
      </v-btn>

      <v-divider vertical></v-divider>

      <v-btn flat color="white" value="Meeting" @click="$router.push('/Supervisor/Meeting')">
        <span>Meeting</span>
        <v-icon>mdi-meetup</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-layout>
</template>

<script>
  import JWT from "jsonwebtoken";

  export default {
    data() {
      return {
        activeBtn: null,
        SystemUserID: null
      };
    },
    watch: {
      $route(route) {
        this.checkRoute();
      }
    },
    mounted() {
      let self = this;

      let sessionData = self.$store.getters.getUserSessionData;
      let tokenDecoded = JWT.decode(sessionData.AccessToken);
      self.SystemUserID = tokenDecoded.USER_ID;

      self.checkRoute();
      //self.FetchAllUserData();
    },
    methods: {
      checkRoute() {
        let route = this.$route;

        if (route.name == "Customers") {
          this.activeBtn = "Customers";

          let checkedInData = this.$store.getters.getLastCheckInData;
          if (checkedInData.VenueID != null) {
            this.$router.push(
              `/Supervisor/Inspections/Allocated/${checkedInData.VenueID}`
            );
          }
        }
        if (route.name == "SupervisorInspections") {
          this.activeBtn = "Customers";
        }
        if (route.name == "Meeting") {
          this.activeBtn = "Meeting";
        }
      },
      FetchAllUserData() {
        let self = this;

        self.get(`Mobile/Supervisor?systemUserID=${self.SystemUserID}`).then(r => {
          console.log("[USERS DATA]", r.data)
        })
      },
      openRoute(route) {
        this.$router.push(route);
      },
      goToHome() {
        this.activeBtn = null;
        this.$router.push("/Supervisor");
      },
      logout() {
        let storeData = {
          CustomerID: null,
          VenueID: null
        };

        this.$store.commit("setLastCheckInData", storeData);
        this.$router.push(`/`);
      }
    }
  };
</script>

<style>
</style>